import React from "react";
import { Box, Typography, Link } from "@mui/material";

function isUrl(val) {
  if (!val || typeof val !== "string") return false;
  return /^https?:\/\//i.test(val.trim());
}

export default function DetailField({ label, value }) {
  return (
    <Box sx={{ mb: 1.5 }}>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      {isUrl(value) ? (
        <Typography variant="body2">
          <Link href={value} target="_blank" rel="noopener noreferrer">
            {value}
          </Link>
        </Typography>
      ) : (
        <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>{value || "—"}</Typography>
      )}
    </Box>
  );
}
